'use client';

import type { ComingSoonProps } from '@/core/types';

import { useCountdownDate } from 'minimal-shared/hooks';

import { useTranslate } from '@/core/locales';

import { ComingSoonIllustration } from '@/assets/illustrations';

import { Social } from '@/components/social';
import { Box, Container, Typography } from '@/components/ui';

export default function ComingSoon({ date, socialLinks = [], className = '' }: ComingSoonProps) {
  const { t } = useTranslate('sections');
  const countdown = useCountdownDate(date || new Date('2026-08-20 20:30'));

  return (
    <Container
      component="section"
      className={`flex flex-col justify-center items-center py-16 ${className}`}
      maxWidth="md"
    >
      <Typography variant="h2" className="mb-2">
        {t('comingSoon.title')}
      </Typography>

      <Typography className="text-gray-600">{t('comingSoon.description')}</Typography>

      <ComingSoonIllustration className="my-5 sm:my-10" />

      <Box className="flex flex-row justify-center text-4xl font-bold">
        <TimeBlock label={t('comingSoon.countdown.days')} value={countdown.days} />
        <Box className="mx-2.5">:</Box>
        <TimeBlock label={t('comingSoon.countdown.hours')} value={countdown.hours} />
        <Box className="mx-2.5">:</Box>
        <TimeBlock label={t('comingSoon.countdown.minutes')} value={countdown.minutes} />
        <Box className="mx-2.5">:</Box>
        <TimeBlock label={t('comingSoon.countdown.seconds')} value={countdown.seconds} />
      </Box>

      <Box className="flex justify-center my-5">
        <Social links={socialLinks} className="max-w-md" />
      </Box>
    </Container>
  );
}

type TimeBlockProps = {
  label: string;
  value: string;
};

function TimeBlock({ label, value }: TimeBlockProps) {
  return (
    <Box className="flex flex-col items-center">
      <span> {value} </span>
      <Box component="span" className="text-gray-600 text-base">
        {label}
      </Box>
    </Box>
  );
}
